
import { Component, Prop, Vue } from "vue-property-decorator";
import { Action, Mutation, State } from "vuex-class";
import Scale from "@/models/scale";
const namespace = "StudioModule";

@Component
export default class Piano extends Vue {
  @State ("scale", { namespace }) private scale!: Scale;
  @State ("selectedOctave", { namespace }) private selectedOctave!: number;
  @State ("baseNote", { namespace }) private baseNote!: string;
  @State ("notesArray", { namespace }) private notesArray!: string[];

  private getDisplay(i:number):string{
    const nBaseNote = this.notesArray.indexOf(this.baseNote);
    if(this.scale.modeTones.includes((i+(12-nBaseNote))%12)){
      return "ff";
    }else{
      return "22";
    }
  }
}
